import HGridData from './HGridData'
import DGridData from './DGridData'
import WGridData from './WGridData'
import tools from '@/sag-core/tools'
import StoreBase from '@/sag-core/base/StoreBase'
export default function Store(serviceName){
    return tools.mergeDeep(
        new StoreBase(serviceName), {
        state: {
            pageGridDatas: [
                HGridData,
                DGridData,
                WGridData
            ],
            pageApiDatas: {
                apiQueryConfig: []
            },
            pageEvents: {}
        }
    })
}

